import React from 'react'
import styled, { keyframes } from 'styled-components'
import GatsbyLink from 'gatsby-link'

import { AnyRecord } from '@/types/prelude.type'

const slideAnimation = keyframes`
  0% {
    background-position: 0;
  }
  100% {
    background-position: -300%;
  }
`

export const GradientButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-family: 'PT Mono', monospace;
  font-size: 16px;
  background: ${({ theme }) =>
    `linear-gradient(to right, ${theme.palette.giphyIndigo}, ${theme.palette.giphyAqua}, ${theme.palette.giphyIndigo})`};
  background-size: 300%;
  background-position: 0% 100%;
  height: 42px;
  width: 176px;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    animation: ${slideAnimation} 3s infinite linear;
  }
`

const Link = styled.a`
  border-bottom: none;
  color: unset;
`

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GradientLinkProps<P = any> = React.ComponentProps<typeof Link> & {
  ButtonProps?: P
  ButtonComponent?: React.FC<P>
}

export const GradientLink: React.FC<GradientLinkProps> = (props) => {
  const { children, ButtonComponent = GradientButton, ButtonProps, ...other } = props

  return (
    <Link {...other}>
      <ButtonComponent {...(ButtonProps as AnyRecord)}>{children}</ButtonComponent>
    </Link>
  )
}

const StyledGatsbyLink = styled(GatsbyLink)`
  border-bottom: none;
  color: unset;
`

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GradientGatsbyLinkProps<P = any> = React.ComponentProps<typeof StyledGatsbyLink> & {
  ButtonProps?: P
  ButtonComponent?: React.FC<P>
}

export const GradientGatsbyLink: React.FC<GradientGatsbyLinkProps> = (props) => {
  const { children, ButtonComponent = GradientButton, ButtonProps, ...other } = props

  return (
    <StyledGatsbyLink {...other}>
      <ButtonComponent {...ButtonProps}>{children}</ButtonComponent>
    </StyledGatsbyLink>
  )
}
